<script lang="ts">
    import {ignoreUnsupportedProperties} from '../../_shared/editors-utils';

    export let value;

    ignoreUnsupportedProperties(value);
</script>

<template>
    <span class="empty-component"></span>;
</template>